import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/**  */
export const useFlagappVerboseErrorDisplay = (): boolean => useINTERNALFlag('app-verbose-error-display');
/**  */
export const FlagappVerboseErrorDisplay = (props: PropsNoName) => <INTERNALFlag name="app-verbose-error-display" {...props}/>
